export const menu = {
  enableInsights: true,
  groups: [
    {
      name: 'Cadastros',
      modules: [
        {
          path: 'vendedores',
          label: 'Vendedores',
          icon: 'storefront',
          roles: ['vendedores-1', 'vendedores-2', 'vendedores-3'],
        },
        {
          path: 'compradores',
          label: 'Compradores',
          icon: 'shopping_cart',
          roles: [
            'compradores-externos-1',
            'compradores-externos-2',
            'compradores-externos-3',
            'compradores-oficinas-1',
            'compradores-oficinas-2',
            'compradores-oficinas-3',
            'compradores-wom-1',
            'compradores-wom-2',
            'compradores-wom-3',
          ],
        },
        {
          path: 'transportadoras',
          label: 'Transportadoras',
          icon: 'local_shipping',
          roles: ['transportadoras-1', 'transportadoras-2', 'transportadoras-3'],
        },
        {
          path: 'cupons',
          label: 'Cupons',
          icon: 'sell',
          roles: ['cupons-listagem'],
        },
        {
          path: 'canais-de-venda',
          label: 'Canais de venda',
          icon: 'real_estate_agent',
          roles: ['canais-de-venda-1', 'canais-de-venda-2', 'canais-de-venda-3'],
        },
        {
          path: 'gestao-de-plataforma',
          label: 'Gestao de plataformas',
          icon: 'lock',
          roles: ['plataformas-listagem'],
        },
        {
          path: 'usuarios',
          label: 'Usuários',
          icon: 'person',
          roles: ['usuarios-listagem'],
        },
      ],
    },
    {
      name: 'Operacional',
      modules: [
        {
          path: 'operacoes',
          label: 'Operações',
          icon: 'settings',
          roles: ['operações-listagem'],
        },
        {
          path: 'estoque-e-preco',
          label: 'Estoque & Preço',
          icon: 'warehouse',
          roles: ['estoque-virtual-listagem'],
          children: [
            {
              path: 'estoque-virtual',
              label: 'Estoque Virtual',
              roles: ['estoque-virtual-listagem'],
            },
            {
              path: 'estoque-por-seller',
              label: 'Estoque por Seller',
            },
          ],
        },
        {
          path: 'vendas',
          label: 'Vendas',
          icon: 'package_2',
          roles: ['vendas-listagem'],
        },
        {
          path: 'compras',
          label: 'Compras',
          icon: 'local_mall',
          roles: ['compras-listagem'],
        },
        {
          path: 'fretes',
          label: 'Fretes',
          icon: 'transportation',
          roles: ['fretes-listagem'],
        },
        {
          path: 'rastreios',
          label: 'Rastreios',
          icon: 'location_on',
          roles: ['rastreios-listagem'],
        },
        {
          path: 'devolucoes',
          label: 'Devoluções',
          icon: 'cycle',
          roles: ['devolucoes-listagem'],
        },
        {
          path: 'logistica-reversa',
          label: 'Logística Reversa',
          icon: 'multiple_stop',
          roles: ['logística-reversa-listagem'],
        },
        {
          path: 'entregas',
          label: 'Entregas',
          icon: 'local_shipping',
          roles: ['entregas-listagem'],
        },
      ],
    },
    {
      name: 'Consultas',
      modules: [
        {
          path: 'produtos',
          label: 'Produtos',
          icon: 'inventory_2',
          roles: ['produtos-consulta'],
        },
      ],
    },
  ],
};
